import React from "react";

export const WordPreview = ({ blocks, onChange }) => {
  if (!blocks || blocks.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-slate-500">
        Nessun contenuto in anteprima.
      </p>
    );
  }

  const update = (i, patch) => {
    const next = blocks.map((b, idx) =>
      idx === i ? { ...b, ...patch } : b
    );
    onChange(next);
  };

  const setTableCell = (i, r, c, value) => {
    const b = blocks[i];
    const rows = b.rows.map((row) => [...row]);
    rows[r][c] = value;
    update(i, { rows });
  };

  return (
    <div data-testid="word-preview" className="max-h-[460px] space-y-3 overflow-auto rounded-xl border border-slate-200 bg-white p-4">
      {blocks.map((b, i) => {
        if (b.type === "table" && b.rows) {
          const maxCols = b.rows.reduce((m, r) => Math.max(m, r.length), 0);
          return (
            <div key={i} className="overflow-x-auto">
              <table className="w-full border-collapse text-sm">
                <tbody>
                  {b.rows.map((row, r) => (
                    <tr key={r} className={r === 0 ? "bg-blue-50" : ""}>
                      {Array.from({ length: maxCols }).map((_, c) => (
                        <td key={c} className="border border-slate-200 p-0">
                          <input
                            value={row[c] ?? ""}
                            onChange={(e) => setTableCell(i, r, c, e.target.value)}
                            className={`w-full min-w-[100px] bg-transparent px-2 py-1 outline-none focus:bg-blue-50 ${
                              r === 0 ? "font-bold" : ""
                            }`}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        }
        if (b.type === "heading") {
          return (
            <input
              key={i}
              value={b.text ?? ""}
              onChange={(e) => update(i, { text: e.target.value })}
              className="w-full border-b border-transparent bg-transparent font-display text-lg font-bold text-slate-900 outline-none focus:border-blue-300"
            />
          );
        }
        return (
          <textarea
            key={i}
            value={b.text ?? ""}
            onChange={(e) => update(i, { text: e.target.value })}
            rows={Math.max(1, Math.ceil((b.text || "").length / 90))}
            className="w-full resize-none rounded-md bg-transparent px-1 py-0.5 text-sm leading-relaxed text-slate-700 outline-none focus:bg-blue-50"
          />
        );
      })}
      <p className="text-xs text-slate-400">
        Modifica testi e tabelle, poi scarica il documento Word aggiornato.
      </p>
    </div>
  );
};
